import Helper from '../../../models/Helper';

import type { PutLearningOutcomeBody } from '../types';

const URI = '/exercises/:id';

/**
 * @desc Helper for exercises.
 */
class ExercisesHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Update learning outcomes.
   * @param {number} exerciseId
   * @param {array} learningOutcomes
   * @return {Promise<Array<LearningOutcome>>} The promise handling the request.
   * @example
   * const courseId = 1234;
   * const learningOutcomes = [{ evaluationCriteria: '', id: 5678 }]
   * const response = await myClient.helpers.assessment.ExercisesHelper.updateLearningOutcomes(courseId, learningOutcomes);
   */
  updateLearningOutcomes(exerciseId: number, learningOutcomes: Array<PutLearningOutcomeBody>) {
    const request = this.api
      .createPutRequest(URI)
      .setRouteParam('id', `${exerciseId}`)
      .setBodyParams(learningOutcomes);

    request.url += '/learning-outcomes';

    return request.execute();
  }
}

export default ExercisesHelper;
